import { Component, OnInit, Output, EventEmitter, Inject } from '@angular/core';
import { agGridValoresGarantizadosDefs } from '../../models/valoresGarantizados-def';
import { Observable } from 'rxjs';
import { PageEvent, MatDialog, MatDialogConfig, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { CotizadorService } from '../../services/cotizador.service';
import { ValoresGarantizados } from '../../models/valoresGarantizados';
import { Prospecto } from '../../models/prospecto';
import { saveAs } from 'file-saver';
import { Planes } from '../../models/planes';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { GridOptions } from 'ag-grid-community';

export interface DialogData {
  anios1: number;
  anios2: string;
  combo:[]
  formato: string;
  edadRetiro: number;
  maxAnios: number;
}

@Component({
  selector: 'app-cotizacion',
  templateUrl: './cotizacion.component.html',
  styleUrls: ['./cotizacion.component.scss']
})
export class CotizacionComponent implements OnInit {

  @Output() CambiaTab = new EventEmitter<number>();

  defaultColDef = {
    resizable: true,
    // pinned: true,
    sortable: true,
    filter: false,
    editable: false,

  };

  rowData: [] = [];
  columnDefs = agGridValoresGarantizadosDefs;
  maxRamos$: Observable<any>;
  private gridApi;
  arrayPlanes = [];
  private gridColumnApi;
  elementosPorPagina = 10;
  opcionesPaginado = [1, 2, 5, 10, 50, 100];
  private paginaActual = 1;
  valoresGarantizados: any;

  anios1: number = 10;
  anios2: string = '10';
  formato: string = 'PROTEGT Retiro';
  edadRetiro: string = '65';
  maxAnios = 0;
  combo = [];
  planes: any;
  prospecto: Prospecto;

  loading = false;
  gridOptions: GridOptions;

  @BlockUI() blockUI: NgBlockUI;

  openDialog(): void {
    const dialogRef = this.dialog.open(DialogOverviewExampleDialog, {
      width: '250px',
      data: { anios1: this.anios1, anios2: this.anios2, formato: this.formato, edadRetiro: this.edadRetiro, maxAnios: this.maxAnios, combo: this.arrayPlanes }
    });


    this.cotizadorService.getPlanes().subscribe((planes: Planes) => {
      this.planes = planes;
    });


    dialogRef.afterClosed().subscribe(result => {
      //debugger;
      this.anios1 = result.anios1;
      this.anios2 = result.anios2;
      this.formato = result.formato;
      this.edadRetiro = result.edadRetiro;
      this.blockUI.start('Generando PDF...');
      if (this.prospecto.genero != "" && this.prospecto.habito != "" && this.prospecto.edad != "") {
        try {
          // this.loading = true;
          if (this.planes.fallPrimaPeso > 0 || this.planes.fallPrimaUdi > 0 || this.planes.fallPrimaDolares > 0) {
            this.cotizadorService.GenerarPDF(this.prospecto, this.planes, this.valoresGarantizados, this.anios1, this.anios2, this.formato, this.edadRetiro).subscribe(data => {


              saveAs(data, 'Cotización.pdf');
              this.loading = false;
              this.blockUI.stop();
            },

              err => {
                this.blockUI.stop();

              }
            );
          }

        } catch (error) {
          console.log('Error: ', error);
          this.blockUI.stop();
        }
      }

    });
  }



  constructor(private cotizadorService: CotizadorService,
    public dialog: MatDialog) { }

  ngOnInit(): void {

    this.obtenerComboLayout();
    this.cotizadorService.getValoresGarantizados().subscribe((valoresGarantizados) => {
      //debugger;
      this.valoresGarantizados = valoresGarantizados;

      if (valoresGarantizados) {
        this.maxAnios = this.valoresGarantizados[this.valoresGarantizados.length - 1].anioPoliza;
      }
      //     
    });

    this.cotizadorService.getProspecto().subscribe((prospecto: Prospecto) => {

      this.prospecto = prospecto;
    });

  }

  /**
     * Se ejecuta este metodo cuando el grid esta renderizado y re ajusta el tamaño de las celdas cuando se cambia de tamaño la pantalla.
     * @param params grid framework object
     */
  onGridReady(params): void {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;

    this.cotizadorService.getValoresGarantizados().subscribe((valoresGarantizados) => {
      this.valoresGarantizados = valoresGarantizados;


      if (this.valoresGarantizados != null) {
        params.api.setRowData(this.valoresGarantizados);

        this.maxAnios = this.valoresGarantizados[this.valoresGarantizados.length - 1].anioPoliza;

      }

    });
  }

  /**
   * Al cambiar de pagina en el paginador cambiamos de datos.
   * @param datosPagina aqui estan los datos de la pagina que se selecciono
   */
  alCambiarPagina(datosPagina: PageEvent): void {
    this.paginaActual = datosPagina.pageIndex + 1;
    this.elementosPorPagina = datosPagina.pageSize;


  }


  /**
     * Se dispara cuando la seleccion de una o mas rows cambia.
     * @param evento contiene todas las row seleccionadas.
     */
  seleccionCambiada(evento: any): void {

  }

  regresarTab(): void {
    this.CambiaTab.emit(1);
  }

  generarPDF(): void {

  }

  obtenerComboLayout(): any {
    this.cotizadorService.ObtenerComboLayout().subscribe(layouts => {
      if (layouts) {
        this.arrayPlanes = layouts.result;
      }
    });
  }

}


@Component({
  selector: 'dialog-overview-example-dialog',
  templateUrl: 'dialog-overview-example-dialog.html',
})
export class DialogOverviewExampleDialog {

  validoAnios = true;
  constructor(
    public dialogRef: MatDialogRef<DialogOverviewExampleDialog>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData) { }

  onNoClick(): void {
    this.dialogRef.close();
  }

  onBlurAnios1(): void {
    debugger;
    this.validoAnios = false;

  }

}